<template>
    <b-modal id="modal-vendor" centered no-close-on-backdrop :footer-class="'d-block p-3 m-0'"
        :body-class="'equipment-edit-modal'" no-close-on-esc scrollable>
        <template #modal-header="{ close }">
            <h5 class="modal-title">
                {{ editVendor ? $t('addUpdateVendor.editTitle') : $t('addUpdateVendor.addTitle') }}
            </h5>
            <b-button size="sm" class="d-none" variant="outline-danger" @click="close()">
                Close Modal
            </b-button>
        </template>
        <div class="body">
            <b-row>
                <b-col cols="12" class="mt-3">
                    <b-form-group :label="$t('addUpdateVendor.nameLabel')" class="text-left mb-0">
                        <b-form-input v-model="vendorPayload.name"
                            :disabled="!allowAddData && (!editVendor || (editVendor && !allowUpdateVendors))"
                            :placeholder="$t('addUpdateVendor.namePlaceholder')" class="unit" required></b-form-input>
                        <p v-if="errors && errors.name" class="field-error">
                            {{ errors.name[0] }}
                        </p>
                    </b-form-group>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-form-group :label="$t('addUpdateVendor.addressLabel')" class="text-left mb-0">
                        <b-form-input v-model="vendorPayload.address"
                            :disabled="!allowAddData && (!editVendor || (editVendor && !allowUpdateVendors))"
                            :placeholder="$t('addUpdateVendor.addressPlaceholder')" class="unit" required></b-form-input>

                    </b-form-group>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-form-group :label="$t('addUpdateVendor.cityLabel')" class="text-left mb-0">
                        <b-form-input v-model="vendorPayload.city"
                            :disabled="!allowAddData && (!editVendor || (editVendor && !allowUpdateVendors))"
                            :placeholder="$t('addUpdateVendor.cityPlaceholder')" class="unit" required></b-form-input>

                    </b-form-group>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-form-group :label="$t('addUpdateVendor.stateLabel')" class="text-left mb-0">
                        <v-select class="bg_white w-100"
                            :disabled="!allowAddData && (!editVendor || (editVendor && !allowUpdateVendors))"
                            v-model="vendorPayload.state" :options="states" item-value="id" item-text="label"
                            :reduce="(option) => option.id" />
                    </b-form-group>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-form-group :label="$t('addUpdateVendor.zipLabel')" class="text-left mb-0">
                        <b-form-input v-model="vendorPayload.zip"
                            :disabled="!allowAddData && (!editVendor || (editVendor && !allowUpdateVendors))"
                            :placeholder="$t('addUpdateVendor.zipPlaceholder')" class="unit" required></b-form-input>

                    </b-form-group>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-form-group :label="$t('addUpdateVendor.phoneLabel')" class="text-left position-relative mb-2">
                        <b-input-group size="lg" class="w-100" prepend="+1">
                            <b-form-input v-mask="phoneMask" v-model="vendorPayload.phone"
                                :disabled="!allowAddData && (!editVendor || (editVendor && !allowUpdateVendors))"
                                :placeholder="$t('addUpdateVendor.phonePlaceholder')"></b-form-input>
                        </b-input-group>
                        <p v-if="errors && errors.phone" class="field-error mt-2">
                            {{ errors.phone[0] }}
                        </p>
                    </b-form-group>
                </b-col>
                <b-col cols="12" class="mt-3">
                    <b-form-group :label="$t('addUpdateVendor.emailLabel')" class="text-left mb-0">
                        <b-form-input v-model="vendorPayload.email"
                            :disabled="!allowAddData && (!editVendor || (editVendor && !allowUpdateVendors))"
                            :placeholder="$t('addUpdateVendor.emailPlaceholder')" class="unit" required></b-form-input>

                    </b-form-group>
                </b-col>
            </b-row>
        </div>
        <template #modal-footer>
            <div class="text-right modal-footer border-0 p-0 mb-0 mt-0 mx-0">
                <b-button class="mx-0 h-40px w-100px m-0"
                    :class="(allowAddData && !editVendor) || (editVendor && allowUpdateVendors) ? 'mr-3' : ''"
                    @click="resetForm()" variant="secondary">{{ $t('maintenanceShared.cancel') }}</b-button>
                <div class="d-flex align-items m-0"
                    v-if="(allowAddData && !editVendor) || (editVendor && allowUpdateVendors)">
                    <b-button class="mx-0 mb-0 h-40px w-100px m-0" variant="primary"
                        @click="updateVendorData()">{{ $t('maintenanceShared.save') }}</b-button>
                </div>
            </div>
        </template>
    </b-modal>
</template>
<script>
import { checkEmail, checkPhoneFormat } from '../../services/helper'
import vSelect from "vue-select";
import { mapGetters, mapActions } from 'vuex'
import "vue-select/dist/vue-select.css";
export default {
    name: "AddandUpdateVendor",
    props: ['editVendor', 'data', 'vendorID', 'states', 'allowAddData'],
    components: { vSelect },
    data() {
        return {
            checkEmail,
            checkPhoneFormat,
            errors: {},
            vendorPayload: {
                name: "",
                address: "",
                city: "",
                state: 54,
                zip: "",
                phone: "",
                email: ""
            },
        }
    },
    methods: {
        ...mapActions([
            "setNotification",
            "updateVendor",
            "addVendor",
        ]),
        checkNullValues(payload) {
            let nullKeys = [];
            for (let [key, value] of Object.entries(payload)) {
                if (!value) {
                    nullKeys.push(key);
                }
            }
            return nullKeys;
        },
        resetForm() {
            this.errors = {}
            this.$bvModal.hide('modal-vendor')
            this.vendorPayload = {
                name: "",
                address: "",
                city: "",
                state: 54,
                zip: "",
                phone: "",
                email: ""
            },
                this.$emit('close')
        },
        async updateVendorData() {
            try {
                this.errors = {}
                if (this.vendorPayload.phone) {
                    if (!this.checkPhoneFormat(this.vendorPayload.phone)) {
                        throw {
                            phone: [this.$t('maintenanceShared.wrongFormat')],
                        };
                    }
                }
                if (this.vendorPayload.email) {
                    if (!this.checkEmail(this.vendorPayload.email)) {
                        throw {
                            phone: [this.$t('maintenanceShared.wrongFormat')],
                        };
                    }
                }
                const nullKeys = this.checkNullValues({
                    name: this.vendorPayload.name
                });
                if (nullKeys.length === 0) {
                    let successMsg = this.$t('addUpdateVendor.vendorAdded')
                    if (this.editVendor) {
                        successMsg = this.$t('addUpdateVendor.vendorUpdated')
                        try {
                            await this.updateVendor({
                                id: this.vendorID,
                                payload: this.vendorPayload
                            })
                        }
                        catch (e) {
                            await this.setNotification({
                                msg: e,
                                type: "error",
                                color: "red",
                            });
                            return
                        }
                    }
                    else {
                        try {
                            await this.addVendor(this.vendorPayload)
                        }
                        catch (e) {
                            await this.setNotification({
                                msg: e,
                                type: "error",
                                color: "red",
                            });
                            return
                        }
                    }
                    await this.setNotification({
                        msg: successMsg,
                        type: "success",
                        color: "green",
                    });
                    this.resetForm()
                    this.$emit('updateVendorList')
                }
                else {
                    let error = {};
                    nullKeys.forEach((x) => {
                        error[x] = [this.$t('maintenanceShared.fieldRequired')];
                    });
                    throw error;
                }
            }
            catch (error) {
                if (typeof error === "object") {
                    this.errors = error;
                    // eslint-disable-next-line no-ex-assign
                }
            }
        },
    },
    computed: {
        ...mapGetters(["rolePermissions", "userCompany"]),
        allowUpdateVendors() {
            return this.rolePermissions && this.rolePermissions['Maintenance'] && this.rolePermissions['Maintenance'][1].allow
        },
        phoneMask() {
            return this.vendorPayload?.phone?.length > 0
                ? [
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, " ",
                    /\d/, /\d/, /\d/, /\d/
                ]
                : false; // Allows empty input
        },
    },
    watch: {
        data: {
            handler() {
                if (this.data) this.vendorPayload = this.data
            },
            deep: true
        }
    }

}
</script>